"use strict";

exports.__esModule = true;
exports.getTimelineAggregateQuery = exports.getAggregationName = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getBins = function getBins(windowType, timezoneName, dimensionColumns) {
  var bins = [];
  if (windowType) {
    bins.push((0, _timeAggregationBinMapping.getTimeAggregationBin)(windowType, {
      timezoneName: timezoneName
    }));
  }
  if (dimensionColumns) {
    bins.push.apply(bins, dimensionColumns.map(function (column) {
      return {
        aggType: "terms",
        binName: "by_" + (column.split(".")[1] || column),
        fieldName: column,
        options: {
          missing: " "
        }
      };
    }));
  }
  return bins;
};
var getAggregationName = exports.getAggregationName = function getAggregationName(fieldName) {
  return "sum-" + fieldName;
};
var getTimelineAggregateQuery = exports.getTimelineAggregateQuery = function getTimelineAggregateQuery(_ref) {
  var type = _ref.type,
    device = _ref.device,
    interval = _ref.interval,
    dimensionColumnIds = _ref.dimensionColumnIds,
    measureColumnIds = _ref.measureColumnIds,
    windowType = _ref.windowType,
    timezoneName = _ref.timezoneName,
    _getAggregationName = _ref.getAggregationName;
  var metricDefinitions = measureColumnIds.map(function (column) {
    return {
      aggregation: "sum",
      fieldName: column,
      name: _getAggregationName ? _getAggregationName(column) : getAggregationName(column)
    };
  });
  return {
    filters: {
      must: [{
        filterType: "terms",
        fieldName: "entity.device",
        values: device
      }, {
        filterType: "terms",
        fieldName: "type",
        values: type
      }, {
        filterType: "range",
        fieldName: "timestamp",
        values: {
          gte: _moment["default"].utc(interval.startMillis).toISOString(),
          lt: _moment["default"].utc(interval.endMillis).toISOString()
        }
      }]
    },
    bins: getBins(windowType, timezoneName, dimensionColumnIds),
    metricDefinitions: metricDefinitions
  };
};